import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AlertCircle, ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/_authenticated/billing/cancel")({
  component: BillingCancelPage,
});

function BillingCancelPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-xl py-12">
      <div className="rounded-2xl border border-border bg-surface p-8 shadow-xl relative overflow-hidden">
        {/* Decorative subtle background gradient */}
        <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-danger/5 blur-3xl pointer-events-none" />

        <div className="flex flex-col items-center text-center">
          {/* Cancel warning icon */}
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-danger/10 text-danger mb-6">
            <AlertCircle size={36} />
          </div>

          <h1 className="text-3xl font-extrabold text-heading tracking-tight mb-3">
            {t("billing.cancelTitle")}
          </h1>

          <p className="text-muted mb-8 max-w-md">{t("billing.cancelSubtitle")}</p>

          {/* Actions */}
          <Link
            to="/billing"
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-border bg-surface py-3 px-4 font-semibold text-heading transition-colors hover:bg-elevated"
          >
            <ArrowLeft size={16} />
            {t("billing.backToPricing")}
          </Link>
        </div>
      </div>
    </div>
  );
}
